import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import LayoutHeader from '../layout/LayoutHeader';
import TimelineSettings from '../components/TimelineSettings';
import { timelineApi } from '../utils/timelineApi';

const TimelineSettingsPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [settings, setSettings] = useState({
    upcomingShows: true,
    upcomingReleases: true,
    tasksDeadlines: true,
    flights: true,
    hotels: true,
    newShowOffers: true,
    ticketCountUpdates: true,
    releaseWorkflowTasks: true
  });

  useEffect(() => {
    // Load saved settings
    const savedSettings = timelineApi.getSettings();
    setSettings(savedSettings);
  }, []);

  const handleSettingChange = (key, value) => {
    const newSettings = {
      ...settings,
      [key]: value
    };
    setSettings(newSettings);
    timelineApi.saveSettings(newSettings);
  };

  return (
    <LayoutHeader>
      <div className="flex justify-center w-full">
        <div className="w-[390px] h-[80vh] flex flex-col items-center relative z-[0]">
          
          {/* Header */}
          <div className="px-4 my-[50px] flex w-full justify-between items-center">
            <span className="text-white text-[14px]" style={{ fontWeight: 300 }}>Timeline Settings</span>
            <span 
              className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70" 
              onClick={() => {
                if (location.state?.fromActivityFeed) {
                  navigate('/activity-feed', { state: { fromSettings: true } });
                } else {
                  navigate(-1);
                }
              }}
            >
              Go back
            </span>
          </div>

          {/* Content */}
          <div className="w-full flex-1 overflow-y-auto px-4">
            <TimelineSettings 
              settings={settings}
              onSettingChange={handleSettingChange}
            />
          </div>
        </div>
      </div>
    </LayoutHeader>
  );
};

export default TimelineSettingsPage;

